export const c1AccountInfoFromSessionStorage = (accountID, key) => {
  const accountInfo = getC1CShellState().c1Accounts?.c1AccountsList.find(
    (account) => account.id === accountID
  );
  return accountInfo ? accountInfo[key] : 'Not Available';
};

export const c1AccountIDFromSessionStorage = () => getC1CShellState().c1Accounts?.c1AccountID;

export const getC1AccountsAPIEndPoint = () => {
  const services = getC1CShellState().c1Services?.c1ServicesList;
  let payloadUrl = '';
  if (services && services.length > 0) {
    const endPointPayload = services.find(({ id }) => id === 'cloudaccounts')?.links;
    if (endPointPayload) {
      payloadUrl = endPointPayload.find((endPoint) => endPoint.rel === 'endpoint')?.href;
    }
  }

  return payloadUrl;
};

/** Other Helper Functions */
const getC1CShellState = () => {
  const c1cShellState = sessionStorage.getItem('C1C_Shell_State');
  if (c1cShellState === null) {
    return {};
  }
  return JSON.parse(c1cShellState || '{}');
};

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Handler for sending custom events to Pendo
 * @param eventName
 * @param params
 */
export const sendEventTrack = (eventName, params) => {
  try {
    if (typeof window['pendo'] !== 'undefined' && eventName) {
      /* eslint-disable */
      pendo?.track(eventName, params);
    }
  } catch (e) {
    console.error('Pendo error: ', e);
  }
};

// TODO: Remove the FeatureFlag check with C1C-11968
const checkGovCloudRegion = () => {
  const isGovCloudDeploymentTarget = ['govcloud-prod', 'govcloud-staging'].includes(
    process.env.DEPLOYMENT_TARGET
  );
  const hasGovCloudFeatureFlag = JSON.parse(
    localStorage.getItem('C1C_GOV_CLOUD_ENABLED') || 'false'
  );
  return isGovCloudDeploymentTarget || hasGovCloudFeatureFlag;
};
export const isGovCloudRegion = checkGovCloudRegion();

export const getV1PortalURL = () => {
  switch (process.env.DEPLOYMENT_TARGET) {
    case 'alpha':
    case 'dev':
      return 'https://signin-int.visionone.trendmicro.com/';
    case 'stage':
      return 'https://signin-xdr.visionone.trendmicro.com/';
    case 'prod':
    default:
      return 'https://signin.v1.trendmicro.com/';
  }
};

export const hasProdLogsEnabled = JSON.parse(
  localStorage.getItem('C1C_PROD_LOGS_ENABLED') || 'false'
);
